import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ProfitabilityApiAdapter } from '../adapters/ProfitabilityApiAdapter';
import type {
  ProfitabilityAdCampaignPatchPayload,
  ProfitabilityAdSpendImportResponse,
} from '../models/Profitability';

const httpClient = createHttpClient(apiClientWH);
const adapter = new ProfitabilityApiAdapter(httpClient);

const AD_SPEND_QUERY_KEY = ['profitability', 'ad-spend'] as const;

export const useImportAdSpend = () => {
  const qc = useQueryClient();
  return useMutation<ProfitabilityAdSpendImportResponse, Error, File>({
    mutationFn: (file) => adapter.importAdSpend(file),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: AD_SPEND_QUERY_KEY });
    },
  });
};

export const usePatchAdSpendCampaign = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }: { id: number; body: ProfitabilityAdCampaignPatchPayload }) =>
      adapter.patchAdSpendCampaign(id, body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: AD_SPEND_QUERY_KEY });
    },
  });
};
